import { z } from 'zod';
import { TopicStage } from './TopicStage';
export var JobLevel = z.object({
    id: z.number(),
    name: z.string(),
});
export var JobFunction = z.object({
    id: z.number(),
    name: z.string(),
});
export var MAX_JOB_TITLES_COUNT = 300;
export var TargetPersona = z.object({
    id: z.number(),
    name: z.string().min(3, 'Name must be at least 3 characters'),
    jobLevels: z.array(JobLevel).min(1, 'Job levels must have at least 1 item'),
    jobFunctions: z
        .array(JobFunction)
        .min(1, 'Job functions must have at least 1 item'),
    jobTitleKeywords: z.string().array(),
    jobTitleExclusionKeywords: z.string().array(),
    buyerRoles: z.string().array(),
    jobTitles: z
        .string()
        .array()
        .max(MAX_JOB_TITLES_COUNT, 'Maximum number of job titles is 300'),
    campaigns: z.array(z.object({
        id: z.string(),
        name: z.string(),
    })),
    createdAt: z.string(),
    createdBy: z.string(),
    createdByDisplayName: z.string(),
    updatedBy: z.string().nullable(),
    updatedByDisplayName: z.string().nullable(),
    updatedAt: z.string().nullable(),
});
export var BaseTargetPersona = TargetPersona.pick({
    id: true,
    name: true,
    jobTitles: true,
    jobTitleKeywords: true,
    buyerRoles: true,
    jobTitleExclusionKeywords: true,
    jobLevels: true,
    jobFunctions: true,
});
export var TargetPersonaTopic = z.object({
    score: z.number(),
    topic: z.string(),
    stage: z.string(),
    jobFunction: z.string(),
    jobLevel: z.string(),
    personaName: z.string(),
});
export var TargetPersonaKeyword = z.object({
    score: z.number(),
    keyword: z.string(),
    jobFunction: z.string(),
    jobLevel: z.string(),
    personaName: z.string(),
});
export var TargetPersonaDynamic1 = z.object({
    interestLevel: z.enum(['High', 'Medium', 'Low']),
    jobFunction: z.string(),
    jobLevel: z.string(),
    personaName: z.string(),
});
export var buyingGroupFilters = z.object({
    keywords: z.array(z.string()).optional(),
    topics: z.array(z.string()).optional(),
    topicStage: z.nativeEnum(TopicStage).optional(),
    domains: z.array(z.string()).optional(),
    customSources: z.array(z.string()).optional(),
    buyerResearchStage: z.array(z.string()).optional(),
    activeSources: z.array(z.number()).length(2),
    minLeads: z.number().optional(),
    minClicks: z.number().optional(),
    minImpressions: z.number().optional(),
    includeContactsCount: z.boolean().optional(),
});
export var defaultBuyingGroupFilters = {
    keywords: [],
    topics: [],
    topicStage: TopicStage.Unspecified,
    domains: [],
    customSources: [],
    buyerResearchStage: [],
    activeSources: [0, 10],
    minLeads: 0,
    minClicks: 0,
    minImpressions: 0,
    includeContactsCount: true,
};
export var TargetPersonaWebVisits = z.object({
    score7: z.number(),
    score30: z.number(),
    score60: z.number(),
    scoreTotal: z.number(),
    personaName: z.string(),
    matchTerm: z.string(),
    jobFunction: z.string(),
    jobLevel: z.string(),
});
//# sourceMappingURL=TargetPersona.js.map